function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoInternetOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 177.834,
  height: 135.729
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5040"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.335 111.682a31.06 31.06 0 0 0 26.95 14.41h112.423a31.061 31.061 0 0 0 3.263-62 45.6 45.6 0 0 0-84.01-21.046 25.852 25.852 0 0 0-34.849 21.029 31.06 31.06 0 0 0-23.777 47.607z",
  "data-name": "Path 5550",
  style: {
    stroke: "#e7792b",
    strokeWidth: 2,
    fill: "none"
  },
  transform: "translate(-1.498 -20.78)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.139 1.928 2.571 17.352h11.568L6.427 32.777 33.419 13.5H17.995L29.563 1.928z",
  "data-name": "Icon metro-power",
  style: {
    fill: "#e7792b"
  },
  transform: "translate(71.432 102.953)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4135",
  transform: "translate(19895.072 294.115)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3879"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.148 56.063c3.853-.061 7.681-.13 15.09-.13s11.762.081 14.547.13",
  "data-name": "Path 5236",
  style: {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: "2.5px",
    fill: "none"
  },
  transform: "translate(-19850.373 -274.573)"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 4.28,
  cy: 4.28,
  r: 4.28,
  "data-name": "Ellipse 181",
  style: {
    fill: "#fff"
  },
  transform: "translate(-19824.832 -247.76)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.28,
  cy: 4.28,
  r: 4.28,
  "data-name": "Ellipse 182",
  style: {
    fill: "#fff"
  },
  transform: "translate(-19794.869 -247.76)"
}))));
export { SvgNoInternetOutline as ReactComponent };
export default __webpack_public_path__ + "images/no-internet-outline.859b2efd.svg";